import { render } from "./boletinprodnuevos.vue?vue&type=template&id=2979776f"
import script from "./boletinprodnuevos.vue?vue&type=script&lang=js"
export * from "./boletinprodnuevos.vue?vue&type=script&lang=js"

import "./boletinprodnuevos.vue?vue&type=style&index=0&id=2979776f&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__